export default "__VITE_ASSET__C6nBr3SN__"